import { render, staticRenderFns } from "./TabAdvanced.vue?vue&type=template&id=3dc3b315&scoped=true"
import script from "./TabAdvanced.vue?vue&type=script&lang=js"
export * from "./TabAdvanced.vue?vue&type=script&lang=js"
import style0 from "./TabAdvanced.vue?vue&type=style&index=0&id=3dc3b315&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3b315",
  null
  
)

export default component.exports